import { IgTypography } from "@intelligems/ig-theme";
import IgMobileDialog from "@intelligems/ig-theme/mobile/IgMobileDialog";

type GoToDesktopReason = "multi-currency" | "duplicate-products";

interface MobileGoToDesktopModalProps {
  open: boolean;
  onClose: () => void;
  onAcknowledge: () => void;
  action: "pause" | "end";
  reason: GoToDesktopReason;
  loading?: boolean;
}

const REASON_MESSAGES: Record<GoToDesktopReason, string> = {
  "multi-currency":
    "Multi-currency price updates cannot be managed from mobile at this time.",
  "duplicate-products":
    "Tests with duplicate products enabled cannot be managed from mobile at this time.",
};

export const MobileGoToDesktopModal = ({
  open,
  onClose,
  onAcknowledge,
  action,
  reason,
  loading = false,
}: MobileGoToDesktopModalProps) => {
  return (
    <IgMobileDialog
      handleNoClick={onClose}
      handleYesClick={onAcknowledge}
      loading={loading}
      noButtonText="Cancel"
      open={open}
      onClose={onClose}
      title="Go to Desktop"
      yesButtonText="Go To Desktop"
    >
      <IgTypography variant="body2">
        {REASON_MESSAGES[reason]} Please go to the desktop version to {action}{" "}
        this test.
      </IgTypography>
    </IgMobileDialog>
  );
};
